import React, { useEffect, useState, useMemo } from "react";
import { useRowSelect, useSortBy, useTable, usePagination } from "react-table";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { useMountedLayoutEffect } from "react-table";

import {
    XeroPagination,
    Table,
} from "components/react-table";

const INITIAL_SELECTED_ROW_IDS = {};

export const GenericTable = ({ columns, fetch, setSelectedRows, queryParams = [], reload = {}, refetch=false, CellChangeCallback = ()=> {return ""}}) => {

    const { t } = useTranslation();
    const history = useHistory();

    
    const _search = window.location.search;
    const params = new URLSearchParams(_search);
    const _pageSize = parseInt(params.get('pageSize') || 25)
    const _page = parseInt(params.get('page')) ||  0
    const [paginationState, setPaginationState] = useState({
        localPageIndex: _page,
        localPageSize: _pageSize
    });

    useEffect(() => {
        gotoPage(0)
    }, [reload]);

    const { data, isLoading, isFetching, error } = useQuery(
        [...queryParams, paginationState.localPageIndex, paginationState.localPageSize, refetch],
        async () => fetch(paginationState.localPageIndex, paginationState.localPageSize),
        {
            keepPreviousData: false
        }
    );

    const memoizedData = useMemo(() => data?.items || [], [data?.items]);

    const table = useTable(
        {
            initialState: {
                pageSize: _pageSize,
                // sortBy: initialSortBy,
                pageIndex: _page,
                selectedRowIds: INITIAL_SELECTED_ROW_IDS
            },
            disableMultiSort: true,
            data:  memoizedData,
            columns: columns,
            noWrapHeaders: true,
            manualSortBy: true,
            manualPagination: true,
            pageCount: data?.pagination?.pageCount || Math.ceil(data?.count / _pageSize || 1) || 9999,
            CellChangeCallback,
        },
        useSortBy,
        usePagination,
        useRowSelect,
    );

    const {
        selectedFlatRows,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageIndex,
        state: { pageIndex, pageSize, sortBy, selectedRowIds },
    } = table;

    useEffect(() => {
        const order = sortBy[0] ? `${sortBy[0].id}` : '';
        const asc = sortBy[0] ? (sortBy[0].desc ? "-" : "") : ""
        history.push({
            pathname: `${window.location.pathname}`,
            search: `?pageSize=${pageSize}&page=${pageIndex}`
        })
        setPaginationState({
            localPageIndex: pageIndex,
            localPageSize: pageSize,
        })
    }, [pageIndex, pageSize, sortBy])

    useMountedLayoutEffect(() => {
        setSelectedRows(selectedFlatRows);
      }, [selectedRowIds]);

    return (
        (isLoading || isFetching) ?
            <div className="text-center p-2 my-2">{t('Loading....')}</div>
            :
            <>
                <Table table={table} size="sm" className="inv-table v-middle" responsive />
                <div>
                    <XeroPagination table={table} className="inv-table" />
                </div>
            </>
    );
};
